(() => {
  const state = { sizeChosen: false, fitChosen: false, customFit: false, chestTooltipSize: '' };
  let chestTooltipTimer;
  const productForm = () => document.querySelector('product-form-component form');
  const assist = () => document.querySelector('[data-neuer-purchase-assist]');
  const normalize = (value) => (value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  const setProperty = (name, value) => {
    const form = productForm();
    if (!form) return;
    const key = 'properties[' + name + ']';
    let input = form.querySelector('input[name="' + key + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      form.append(input);
    }
    input.value = value || '';
  };
  const isGateRequired = () => {
    const root = assist();
    return Boolean(root && root.dataset.showSizeFit === 'true' && root.dataset.requireSizeFit === 'true' && optionExists('size'));
  };
  const refreshButtons = () => {
    const show = !isGateRequired() || (state.sizeChosen && state.fitChosen);
    document.querySelectorAll('add-to-cart-component, .shopify-payment-button, [data-testid="accelerated-checkout"], shopify-accelerated-checkout').forEach((node) => {
      node.hidden = !show;
      node.setAttribute('aria-hidden', String(!show));
    });
    document.querySelectorAll('[data-neuer-fit-message]').forEach((node) => { node.hidden = show; });
    updateStickyButtonVisibility();
  };
  const optionExists = (word) => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return false;
    return Array.from(picker.querySelectorAll('[data-option-name], select[name]')).some((control) => {
      const name = (control.dataset.optionName || control.name || '').toLowerCase();
      return name.includes(word);
    });
  };
  const mountSizeFitControls = () => {
    const root = assist();
    const mount = root?.querySelector('[data-neuer-size-fit-mount]');
    if (!root || !mount) return;
    const picker = document.querySelector('variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker');
    if (picker) {
      picker.hidden = false;
      if (!mount.contains(picker)) mount.prepend(picker);
      picker.querySelectorAll('fieldset').forEach((fieldset) => {
        const optionControl = fieldset.querySelector('[data-option-name], input[name], select[name]');
        const optionName = (optionControl?.dataset.optionName || optionControl?.name || '').toLowerCase();
        if (optionName.includes('size')) fieldset.dataset.neuerSizeFieldset = '';
        if (optionName.includes('fit')) fieldset.hidden = root.dataset.showSizeFit !== 'true';
      });
    }
    configureChestTooltips(picker);
    if (mount.querySelector('[data-neuer-generated-panel]')) return;
    const hasSize = optionExists('size');
    const hasFit = optionExists('fit');
    state.customFit = !hasFit;
    if (!hasSize || hasFit || root.dataset.showSizeFit !== 'true') return;
    const panel = document.createElement('div');
    panel.className = 'neuer-purchase-assist__panel';
    panel.dataset.neuerGeneratedPanel = '';
    const fieldset = document.createElement('fieldset');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'neuer-purchase-assist__fits';
    button.dataset.neuerFitChoice = root.dataset.fitOption || 'Relaxed';
    button.setAttribute('aria-pressed', 'false');
    button.textContent = button.dataset.neuerFitChoice;
    fieldset.append(button);
    panel.append(fieldset);
    mount.append(panel);
  };
  const chestRangeForSize = (size) => {
    const entry = (assist()?.dataset.chestRanges || '').split(';').map((part) => part.trim()).find((part) => normalize(part.split(':')[0]) === normalize(size));
    return entry?.slice(entry.indexOf(':') + 1).trim() || '';
  };
  const configureChestTooltips = (picker) => {
    const root = assist();
    if (!root || !picker || root.dataset.showChestRange !== 'true') return;
    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const input = fieldset.querySelector('[data-option-name], input[name]');
      if ((input?.dataset.optionName || input?.name || '').toLowerCase().includes('size')) {
        fieldset.dataset.neuerSizeFieldset = '';
      }
    });
    picker.querySelectorAll('[data-neuer-size-fieldset] input[type="radio"]').forEach((input) => {
      const label = input.closest('label');
      const range = chestRangeForSize(input.value);
      if (!label) return;
      if (!range) {
        delete label.dataset.neuerChestTooltip;
        input.removeAttribute('aria-description');
        return;
      }
      const description = (root.dataset.chestRangeLabel || 'Garment chest range') + ' ' + range;
      label.dataset.neuerChestTooltip = description;
      input.setAttribute('aria-description', description);
      label.classList.toggle('is-chest-tooltip-active', normalize(input.value) === normalize(state.chestTooltipSize));
    });
    if (state.chestTooltipSize) positionChestTooltip();
  };
  const hideChestTooltip = () => {
    window.clearTimeout(chestTooltipTimer);
    state.chestTooltipSize = '';
    document.querySelector('[data-neuer-chest-overlay]')?.setAttribute('hidden', '');
    assist()?.querySelectorAll('.is-chest-tooltip-active').forEach((label) => label.classList.remove('is-chest-tooltip-active'));
  };
  const positionChestTooltip = () => {
    const root = assist();
    const label = Array.from(root?.querySelectorAll('[data-neuer-size-fieldset] label[data-neuer-chest-tooltip]') || [])
      .find((node) => normalize(node.querySelector('input')?.value) === normalize(state.chestTooltipSize));
    if (!label) {
      document.querySelector('[data-neuer-chest-overlay]')?.setAttribute('hidden', '');
      return;
    }
    let tooltip = document.querySelector('[data-neuer-chest-overlay]');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.dataset.neuerChestOverlay = '';
      tooltip.className = 'neuer-chest-tooltip-overlay';
      tooltip.setAttribute('role', 'tooltip');
      document.body.append(tooltip);
    }
    tooltip.textContent = label.dataset.neuerChestTooltip;
    tooltip.hidden = false;
    const rect = label.getBoundingClientRect();
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight;
    if (rect.bottom <= 0 || rect.top >= height) {
      tooltip.hidden = true;
      return;
    }
    const bounds = label.closest('fieldset').getBoundingClientRect();
    const leftLimit = Math.max(8, bounds.left);
    const rightLimit = Math.min(width - 8, bounds.right);
    tooltip.style.maxWidth = Math.max(0, rightLimit - leftLimit) + 'px';
    const tipRect = tooltip.getBoundingClientRect();
    const left = Math.max(leftLimit, Math.min(rect.left + rect.width / 2 - tipRect.width / 2, rightLimit - tipRect.width));
    const above = rect.top - tipRect.height - 10;
    const top = above >= 8 ? above : Math.min(height - tipRect.height - 8, rect.bottom + 10);
    tooltip.style.left = left + 'px';
    tooltip.style.top = Math.max(8, top) + 'px';
    tooltip.style.setProperty('--neuer-tooltip-arrow', Math.max(8, Math.min(tipRect.width - 8, rect.left + rect.width / 2 - left)) + 'px');
    tooltip.dataset.placement = above >= 8 ? 'above' : 'below';
  };
  const showChestTooltip = (size) => {
    const root = assist();
    if (!root || root.dataset.showChestRange !== 'true') return;
    window.clearTimeout(chestTooltipTimer);
    state.chestTooltipSize = size;
    configureChestTooltips(root.querySelector('variant-picker'));
    chestTooltipTimer = window.setTimeout(() => {
      hideChestTooltip();
    }, 3200);
  };
  const onChestPointerOver = (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const label = event.target.closest('variant-picker label');
    const input = label?.querySelector('input[type="radio"]');
    if (!input || !(input.dataset.optionName || input.name || '').toLowerCase().includes('size')) return;
    configureChestTooltips(label.closest('variant-picker'));
    if (!label.dataset.neuerChestTooltip) return;
    if (event.relatedTarget instanceof Node && label.contains(event.relatedTarget)) return;
    showChestTooltip(input.value);
    window.clearTimeout(chestTooltipTimer);
  };
  const onChestPointerOut = (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const label = event.target.closest('label[data-neuer-chest-tooltip]');
    if (label && !(event.relatedTarget instanceof Node && label.contains(event.relatedTarget))) hideChestTooltip();
  };
  const formatBaselineTitle = () => {
    const title = document.querySelector('.product-details h1');
    if (!title || title.dataset.neuerTitleFormatted === 'true') return;
    const original = title.textContent.trim();
    if (!/^Baseline Crew Neck Short Sleeves(?:\s|$)/i.test(original)) return;
    title.dataset.neuerTitleFormatted = 'true';
    title.replaceChildren(...['Baseline', 'Crew neck', 'Short sleeves'].map((line) => {
      const span = document.createElement('span');
      span.className = 'neuer-pdp-title__line';
      span.textContent = line;
      return span;
    }));
  };
  const alignPriceWithSwatches = () => {
    const details = document.querySelector('.product-details');
    const swatches = details?.querySelector('.neuer-color-swatches');
    const price = details?.querySelector('product-price');
    if (!swatches || !price) return;
    const items = swatches.querySelector('.neuer-color-swatches__items');
    if (!items) return;
    let row = swatches.querySelector('.neuer-pdp-colour-price');
    if (!row) {
      row = document.createElement('div');
      row.className = 'neuer-pdp-colour-price';
    }
    const label = swatches.querySelector('.neuer-color-swatches__label');
    if (label && label.parentElement !== swatches) swatches.prepend(label);
    if (items.parentElement !== row) row.prepend(items);
    if (price.parentElement !== row) row.append(price);
    if (row.parentElement !== swatches) swatches.append(row);
  };
  const onControlClick = (event) => {
    if (window.matchMedia('(max-width: 749px)').matches) {
      const sizeLabel = event.target.closest('[data-neuer-size-fieldset] label[data-neuer-chest-tooltip]');
      if (sizeLabel) showChestTooltip(sizeLabel.querySelector('input[type="radio"]')?.value || '');
    }
    const selectSizeColor = event.target.closest('[data-neuer-scroll-to-options]');
    if (selectSizeColor) {
      const target = document.getElementById(selectSizeColor.dataset.neuerScrollToOptions);
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const openSizeChart = event.target.closest('[data-neuer-size-chart-open]');
    if (openSizeChart) {
      const dialog = document.getElementById(openSizeChart.dataset.neuerSizeChartOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closeSizeChart = event.target.closest('[data-neuer-size-chart-close]');
    if (closeSizeChart) {
      closeSizeChart.closest('[data-neuer-size-chart-dialog]')?.close();
      return;
    }
    const backdropDialog = event.target.closest('dialog[data-neuer-size-chart-dialog]');
    if (backdropDialog && event.target === backdropDialog) {
      backdropDialog.close();
      return;
    }
    const nativeSizeControl = event.target.closest('input[type="radio"]');
    const nativeName = (nativeSizeControl?.dataset.optionName || nativeSizeControl?.name || '').toLowerCase();
    if (nativeSizeControl && nativeName.includes('size')) {
      state.sizeChosen = Boolean(nativeSizeControl.value);
      showChestTooltip(nativeSizeControl.value);
      state.fitChosen = false;
      document.querySelectorAll('[data-neuer-fit-choice]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      if (state.customFit) setProperty('Fit', '');
      refreshButtons();
    }
    const fitButton = event.target.closest('[data-neuer-fit-choice]');
    if (fitButton && state.sizeChosen) {
      state.fitChosen = normalize(fitButton.dataset.neuerFitChoice) === normalize(assist()?.dataset.fitOption || 'Relaxed');
      document.querySelectorAll('[data-neuer-fit-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button === fitButton && state.fitChosen)));
      if (state.customFit) setProperty('Fit', state.fitChosen ? fitButton.dataset.neuerFitChoice : '');
      refreshButtons();
    }
    const pincodeButton = event.target.closest('[data-neuer-pincode-check]');
    if (pincodeButton) {
      const checker = pincodeButton.closest('[data-neuer-pincode-checker]');
      const input = checker?.querySelector('[data-neuer-pincode-input]');
      const status = checker?.querySelector('[data-neuer-pincode-status]');
      const pin = (input?.value || '').replace(/\D/g, '').slice(0, 6);
      if (input) input.value = pin;
      if (!/^\d{6}$/.test(pin)) {
        status.textContent = checker.dataset.invalidMessage || 'Enter a valid 6-digit pincode.';
        status.dataset.valid = 'false';
        return;
      }
      const prefixes = (checker?.dataset.metroPrefixes || '').split(/[\s,]+/).map((value) => value.trim()).filter(Boolean);
      const available = prefixes.includes(pin.slice(0, 3));
      status.textContent = available ? (checker.dataset.availableMessage || 'Delivery is available.') : (checker.dataset.unavailableMessage || 'Delivery is unavailable for this pincode.');
      status.dataset.valid = String(available);
    }
  };
  const onInput = (event) => {
    const input = event.target.closest('[data-neuer-pincode-input]');
    if (!input) return;
    input.value = input.value.replace(/\D/g, '').slice(0, 6);
    const status = input.closest('[data-neuer-pincode-checker]')?.querySelector('[data-neuer-pincode-status]');
    if (status) {
      status.textContent = '';
      delete status.dataset.valid;
    }
  };
  const onOptionChange = (event) => {
    const control = event.target.closest('input, select');
    if (!control) return;
    const optionName = (control.dataset.optionName || control.name || '').toLowerCase();
    const value = control.value || '';
    if (optionName.includes('color')) {
      const url = control.dataset.connectedProductUrl || control.selectedOptions?.[0]?.dataset.connectedProductUrl;
      if (url) { window.location.assign(url); return; }
    }
    if (optionName.includes('size')) {
      state.sizeChosen = Boolean(value);
      showChestTooltip(value);
      state.fitChosen = false;
      document.querySelectorAll('[data-neuer-fit-choice]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      if (state.customFit) setProperty('Fit', '');
    } else if (optionName.includes('fit')) {
      const expected = normalize(assist()?.dataset.fitOption || 'Relaxed');
      state.fitChosen = state.sizeChosen && normalize(value) === expected;
    }
    refreshButtons();
  };
  const applyStyles = () => {
    if (document.querySelector('[data-neuer-pdp-styles]')) return;
    const style = document.createElement('style');
    style.dataset.neuerPdpStyles = '';
    style.textContent = `
      .product-information.section { background:#fff; }
      .product-details { color:#171717; }
      .neuer-purchase-assist [data-neuer-size-fieldset] > label[data-neuer-chest-tooltip]::before,
      .neuer-purchase-assist [data-neuer-size-fieldset] > label[data-neuer-chest-tooltip]::after { display:none!important; content:none!important; }
      .neuer-chest-tooltip-overlay { position:fixed; z-index:2147483647; box-sizing:border-box; width:max-content; min-width:0; padding:8px 10px; border-radius:3px; background:#3e4257; color:#fff; font-size:11px; font-weight:500; line-height:1.3; text-align:center; white-space:normal; overflow-wrap:anywhere; pointer-events:none; box-shadow:0 3px 8px rgb(0 0 0 / .16); }
      .neuer-chest-tooltip-overlay[hidden] { display:none!important; }
      .neuer-chest-tooltip-overlay::after { content:''; position:absolute; left:var(--neuer-tooltip-arrow); transform:translateX(-50%); border:6px solid transparent; }
      .neuer-chest-tooltip-overlay[data-placement="above"]::after { top:100%; border-top-color:#3e4257; border-bottom:0; }
      .neuer-chest-tooltip-overlay[data-placement="below"]::after { bottom:100%; border-bottom-color:#3e4257; border-top:0; }
      body > .neuer-purchase-assist__sticky-button { left:0!important; right:0!important; inset-inline:0!important; width:auto!important; max-width:100%!important; min-width:0!important; margin:0!important; box-sizing:border-box!important; transform:none!important; }
      .product-details .neuer-color-swatches__label { margin:0 0 .9rem; }
      .product-details .neuer-pdp-colour-price { display:flex; align-items:flex-start; justify-content:space-between; gap:1rem; margin-bottom:0; }
      .product-details .neuer-pdp-colour-price .neuer-color-swatches__items { flex:1; min-width:0; }
      .product-details .neuer-pdp-colour-price product-price { width:auto; flex-shrink:0; text-align:right; }
      .product-details > .group-block > .group-block-content > .group-block:has(h1):has(product-price) > .group-block-content { display:grid; grid-template-columns:minmax(0,7fr) minmax(0,3fr); align-items:end; column-gap:1rem; row-gap:.5rem; }
      .product-details > .group-block > .group-block-content > .group-block:has(h1):has(product-price) product-price { grid-column:2; grid-row:1; align-self:end; width:100%; min-width:0; text-align:right; font-size:1.15rem; }
      .product-details > .group-block > .group-block-content > .group-block:has(h1):has(product-price) .neuer-product-field { grid-column:1/-1; }
      .product-details .group-block:has(.neuer-pdp-title__line):has(product-price) > .group-block-content { grid-template-columns:minmax(0,1fr) auto; }
      .product-details .group-block:has(.neuer-pdp-title__line):has(product-price) .neuer-product-title { grid-column:1/-1; grid-row:1; width:100%; max-width:none; }
      .product-details .group-block:has(.neuer-pdp-title__line):has(product-price) h1 { width:100%; max-width:none; }
      .neuer-pdp-title__line { display:block; }
      .product-details .neuer-color-swatches { margin-block:0!important; }
      .product-details .neuer-color-swatches__items { row-gap:.4rem; padding-block:0 4px; }
      .product-details .neuer-purchase-assist { margin-block:.25rem!important; }
      .product-details .neuer-purchase-assist__options { margin-block:.4rem!important; }
      .product-details .neuer-pdp-concept { gap:.75rem; }
      .product-details .neuer-pdp-concept__proof { display:flex; flex-wrap:wrap; gap:1rem; border:0; }
      .product-details .neuer-pdp-concept__proof span { display:block; padding:0 0 .2rem; border:0; border-bottom:1px solid currentColor; font-size:.76rem; letter-spacing:.03em; }
      .product-details .neuer-pdp-concept__proof span b { margin-right:.28rem; font-size:inherit; letter-spacing:inherit; text-transform:none; }
      .product-details .neuer-pdp-concept__bundle { display:none; }
      .product-details add-to-cart-component .button { min-height:54px; letter-spacing:.14em; text-transform:uppercase; }
      .product-details .shopify-payment-button__button { min-height:54px; border:1px solid #151515; border-radius:0; background:#fff; color:#151515; letter-spacing:.14em; text-transform:uppercase; }
      .product-details .buy-buttons-block .product-form-buttons:has(.quantity-selector) { align-items:stretch!important; }
      .product-details .buy-buttons-block .product-form-buttons .quantity-selector-wrapper { height:var(--height-buy-buttons); align-self:stretch; align-items:stretch; }
      .product-details .buy-buttons-block .product-form-buttons .quantity-selector,
      .product-details .buy-buttons-block .product-form-buttons .add-to-cart-button {
        box-sizing:border-box!important; height:var(--height-buy-buttons)!important; min-height:var(--height-buy-buttons)!important; max-height:var(--height-buy-buttons)!important; align-self:stretch;
      }
      .product-details .buy-buttons-block .product-form-buttons .add-to-cart-button { padding-block:0!important; }
      @media(max-width:749px) {
        .product-details .neuer-pdp-title__colour { display:none; }
        .product-information media-gallery slideshow-arrows { mix-blend-mode:normal; }
        .product-information media-gallery slideshow-arrows .slideshow-control { width:36px; min-width:36px; height:36px; min-height:36px; margin-inline:8px; padding:8px;  color:#171717; opacity:1; }
        .product-information media-gallery slideshow-arrows .slideshow-control svg { width:18px; height:18px; }
        .product-information media-gallery slideshow-controls .slideshow-controls__dots,
        .product-information media-gallery slideshow-controls .slideshow-controls__counter,
        .product-information media-gallery slideshow-controls .slideshow-controls__thumbnails-container { display:none!important; }
        .product-information media-gallery slideshow-controls:has(.slideshow-controls__dots, .slideshow-controls__counter, .slideshow-controls__thumbnails-container):not(:has(.slideshow-controls__arrows)) { display:none!important; }
      }
      .neuer-description--collapsed { display:-webkit-box; overflow:hidden; -webkit-box-orient:vertical; -webkit-line-clamp:2; }
      .neuer-description-toggle { margin:.3rem 0 0; padding:0; border:0; background:none; color:inherit; font-size:.8rem; font-style:italic; text-decoration:underline; text-underline-offset:3px; cursor:pointer; }
      .neuer-product-meta details { border-color:#ddd; }
      .neuer-purchase-assist__fit-note { margin:.55rem 0 0; color:#555; font-size:.72rem; font-style:italic; }
      .neuer-purchase-assist [data-neuer-size-fit-mount] { display:flex; flex-direction:column; gap:.55rem; }
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker { display:block; width:100%; margin:0!important; padding:0!important; }
      .neuer-purchase-assist [data-neuer-size-fit-mount] .variant-picker__form { display:block; width:100%; }
      .neuer-purchase-assist [data-neuer-size-fieldset],
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) {
        display:flex!important; flex-wrap:wrap!important; align-items:stretch!important; align-content:flex-start!important;
        justify-content:flex-start!important; gap:4px!important; column-gap:4px!important; row-gap:4px!important;
        width:100%!important; margin:0!important; padding:0!important; border:0!important;
      }
      .neuer-purchase-assist[data-variant-button-width="equal-width-buttons"] [data-neuer-size-fieldset],
      .neuer-purchase-assist[data-variant-button-width="equal-width-buttons"] [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) {
        display:grid!important; grid-template-columns:repeat(5,minmax(0,1fr))!important; gap:4px!important; column-gap:4px!important; row-gap:4px!important;
      }
      .neuer-purchase-assist[data-variant-button-width="default-width-buttons"] [data-neuer-size-fieldset] .variant-option__button-label { flex:0 1 auto; width:fit-content; min-width:60px; }
      .neuer-purchase-assist[data-variant-button-width="equal-width-buttons"] [data-neuer-size-fieldset] .variant-option__button-label { width:100%; }
      .neuer-purchase-assist [data-neuer-size-fieldset] > legend,
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) > legend { display:none!important; }
      .neuer-purchase-assist [data-neuer-size-fieldset] .variant-option__button-label,
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label {
        box-sizing:border-box!important; display:grid!important; flex:0 0 auto; width:max-content; min-width:60px; height:44px; min-height:44px; margin:0!important; padding:.4rem .65rem!important; place-items:center; border:1px solid #bbb!important; border-radius:0!important; background:transparent!important; color:#333!important; font-weight:400!important; line-height:1!important; text-align:center; transform:none!important; box-shadow:none!important;
      }
      .neuer-purchase-assist[data-variant-button-width="equal-width-buttons"] [data-neuer-size-fieldset] .variant-option__button-label,
      .neuer-purchase-assist[data-variant-button-width="equal-width-buttons"] [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label { width:100%; min-width:0; }
      .neuer-purchase-assist [data-neuer-size-fieldset] .variant-option__button-label:has(input:checked),
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label:has(input:checked) { border-color:#111!important; background:transparent!important; color:#111!important; font-weight:600!important; box-shadow:inset 0 0 0 1px #111!important; }
      .neuer-purchase-assist [data-neuer-size-fieldset] .variant-option__button-label:hover,
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label:hover { border-color:#111!important; background:transparent!important; }
      .neuer-purchase-assist [data-neuer-size-fieldset] .variant-option__button-label__pill,
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label__pill { display:none!important; }
      .neuer-purchase-assist [data-neuer-size-fieldset] .variant-option__button-label::before,
      .neuer-purchase-assist [data-neuer-size-fit-mount] variant-picker fieldset:has([data-option-name*="size" i]) .variant-option__button-label::before { border-width:1px!important; }
      .neuer-purchase-assist .neuer-purchase-assist__fits { min-height:44px; border:1px solid #111; border-radius:0; background:#111; color:#fff; place-items:center; text-align:center; }
      .neuer-purchase-assist .neuer-purchase-assist__fit-note { line-height:1.45; }
      .neuer-product-meta summary { font-size:.68rem; letter-spacing:.12em; }
      @media(max-width:749px) {
        .product-details > .group-block > .group-block-content > .group-block:has(h1):has(product-price) > .group-block-content { column-gap:.5rem; }
      }
    `;
    document.head.append(style);
  };
  const updateStickyButtonVisibility = () => {
    const scope = document.querySelector('.product-details') || document.querySelector('product-form-component');
    const buyButtonsBlock = scope?.querySelector('.buy-buttons-block');
    const addButton = buyButtonsBlock?.querySelector('.add-to-cart-button, button[name="add"]');
    const addRect = addButton?.getBoundingClientRect();
    const anchorRect = addRect?.width > 0 && addRect?.height > 0
      ? addRect
      : buyButtonsBlock?.getBoundingClientRect();
    const showSticky = Boolean(anchorRect?.width > 0 && anchorRect?.height > 0 && anchorRect.bottom <= 0);
    document.querySelectorAll('[data-neuer-scroll-to-options]').forEach((button) => {
      button.dataset.visible = String(showSticky);
      button.setAttribute('aria-hidden', String(!showSticky));
      button.tabIndex = showSticky ? 0 : -1;
    });
  };
  const mountStickyButtons = () => {
    const seenTargets = new Set();
    document.querySelectorAll('[data-neuer-scroll-to-options]').forEach((button) => {
      const targetId = button.dataset.neuerScrollToOptions;
      if (!targetId || !document.getElementById(targetId) || seenTargets.has(targetId)) {
        button.remove();
        return;
      }
      seenTargets.add(targetId);
      if (button.parentElement !== document.body) document.body.append(button);
    });
    updateStickyButtonVisibility();
  };
  const applyDescriptionToggle = () => {
    const root = assist();
    if (!root || root.dataset.showDescriptionToggle !== 'true') return;
    const details = document.querySelector('.product-details');
    if (!details) return;
    const candidates = Array.from(details.querySelectorAll('.text-block.rte, .rte')).filter((node) => node.textContent.trim().length > 180);
    const description = candidates[candidates.length - 1];
    if (!description || description.dataset.neuerExpandable) return;
    description.dataset.neuerExpandable = '';
    description.classList.add('neuer-description--collapsed');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'neuer-description-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = root.dataset.readMoreText || 'Read more';
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      description.classList.toggle('neuer-description--collapsed', expanded);
      toggle.textContent = expanded ? (root.dataset.readMoreText || 'Read more') : (root.dataset.readLessText || 'Read less');
    });
    description.insertAdjacentElement('afterend', toggle);
  };
  const startPurchaseAssistObserver = () => {
    const observationRoot = window.matchMedia('(max-width: 749px)').matches
      ? document.body
      : document.querySelector('main[data-template^="product"]') || document.querySelector('[data-testid="product-information"]');
    if (!observationRoot || observationRoot.dataset.neuerPdpObserver === 'true') return;
    observationRoot.dataset.neuerPdpObserver = 'true';
    let refreshScheduled = false;
    const relevantSelector = '[data-neuer-purchase-assist], variant-picker, .product-details';
    const nodeIsRelevant = (node) => {
      if (!(node instanceof Element)) return false;
      return node.matches(relevantSelector) || Boolean(node.querySelector(relevantSelector));
    };
    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) => {
        if (record.type === 'attributes') return record.attributeName === 'data-neuer-size-fieldset' && !record.target.hasAttribute('data-neuer-size-fieldset');
        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        return Boolean(target?.closest('[data-neuer-purchase-assist], variant-picker'))
          || Array.from(record.addedNodes).some(nodeIsRelevant)
          || Array.from(record.removedNodes).some(nodeIsRelevant);
      });
      if (!relevant || refreshScheduled) return;
      refreshScheduled = true;
      window.setTimeout(() => {
        refreshScheduled = false;
        mountStickyButtons();
        formatBaselineTitle();
        alignPriceWithSwatches();
        updateStickyButtonVisibility();
        if (!assist()) return;
        mountSizeFitControls();
        applyDescriptionToggle();
        refreshButtons();
      }, 120);
    });
    observer.observe(observationRoot, window.matchMedia('(max-width: 749px)').matches
      ? { childList: true, subtree: true, attributes: true, attributeFilter: ['data-neuer-size-fieldset'] }
      : { childList: true, subtree: true, attributes: true, attributeFilter: ['data-neuer-size-fieldset'] });
  };
  const init = () => {
    if (!document.querySelector('main[data-template^="product"], [data-testid="product-information"]')) return;
    applyStyles();
    formatBaselineTitle();
    alignPriceWithSwatches();
    mountSizeFitControls();
    mountStickyButtons();
    applyDescriptionToggle();
    if (!document.documentElement.dataset.neuerPdpBound) {
      document.documentElement.dataset.neuerPdpBound = 'true';
      document.addEventListener('click', onControlClick);
      document.addEventListener('input', onInput);
      document.addEventListener('change', onOptionChange);
      document.addEventListener('pointerover', onChestPointerOver);
      document.addEventListener('pointerout', onChestPointerOut);
      document.addEventListener('focusin', (event) => {
        const input = event.target.closest('[data-neuer-size-fieldset] input[type="radio"]');
        if (input && input.matches(':focus-visible')) showChestTooltip(input.value);
      });
      document.addEventListener('focusout', (event) => {
        if (event.target.closest('[data-neuer-size-fieldset]')) hideChestTooltip();
      });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') hideChestTooltip(); });
      window.addEventListener('scroll', positionChestTooltip, { passive: true });
      window.addEventListener('resize', positionChestTooltip);
      window.addEventListener('scroll', updateStickyButtonVisibility, { passive: true });
      const pageScroller = document.querySelector('.page-wrapper');
      pageScroller?.addEventListener('scroll', updateStickyButtonVisibility, { passive: true });
      window.addEventListener('resize', updateStickyButtonVisibility);
    }
    refreshButtons();
    startPurchaseAssistObserver();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();